var _a, _b, _c, _d, _e;
import { createCustomAction, EActionState } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./insurance.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["GetInsurance"] = "GET_INSURANCE";
    EActionCustom["ResendInsuranceInviteExternal"] = "RESEND_INSURANCE_INVITE_EXTERNAL";
    EActionCustom["PollInsuranceStatusExternal"] = "POLL_INSURANCE_STATUS_EXTERNAL";
    EActionCustom["ResetInsuranceProposal"] = "RESET_INSURANCE_PROPOSAL";
    EActionCustom["GetInsuranceForContract"] = "GET_INSURANCE_FOR_CONTRACT";
})(EActionCustom || (EActionCustom = {}));
var generateGetInsuranceActions = function () { return ({
    getInsuranceStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetInsurance,
        state: EActionState.Start,
    }),
    getInsuranceSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetInsurance,
        state: EActionState.Success,
    }),
    getInsuranceFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetInsurance,
        state: EActionState.Fail,
    }),
}); };
var generateResendInsuranceInviteExternalActions = function () { return ({
    resendInsuranceInviteExternalStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.ResendInsuranceInviteExternal,
        state: EActionState.Start,
    }),
    resendInsuranceInviteExternalSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.ResendInsuranceInviteExternal,
        state: EActionState.Success,
    }),
    resendInsuranceInviteExternalFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.ResendInsuranceInviteExternal,
        state: EActionState.Fail,
    }),
}); };
var generatePollInsuranceStatusExternalActions = function () { return ({
    pollInsuranceStatusExternalStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.PollInsuranceStatusExternal,
        state: EActionState.Start,
    }),
    pollInsuranceStatusExternalSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.PollInsuranceStatusExternal,
        state: EActionState.Success,
    }),
    pollInsuranceStatusExternalFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.PollInsuranceStatusExternal,
        state: EActionState.Fail,
    }),
}); };
var generateResetInsuranceProposalActions = function () { return ({
    resetInsuranceProposalStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.ResetInsuranceProposal,
        state: EActionState.Start,
    }),
    resetInsuranceProposalSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.ResetInsuranceProposal,
        state: EActionState.Success,
    }),
    resetInsuranceProposalFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.ResetInsuranceProposal,
        state: EActionState.Fail,
    }),
}); };
var generateGetInsuranceForContractActions = function () { return ({
    getInsuranceForContractStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetInsuranceForContract,
        state: EActionState.Start,
    }),
    getInsuranceForContractSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetInsuranceForContract,
        state: EActionState.Success,
    }),
    getInsuranceForContractFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetInsuranceForContract,
        state: EActionState.Fail,
    }),
}); };
export var getInsuranceStart = (_a = generateGetInsuranceActions(), _a.getInsuranceStart), getInsuranceSucceeded = _a.getInsuranceSucceeded, getInsuranceFailed = _a.getInsuranceFailed;
export var resendInsuranceInviteExternalStart = (_b = generateResendInsuranceInviteExternalActions(), _b.resendInsuranceInviteExternalStart), resendInsuranceInviteExternalSucceeded = _b.resendInsuranceInviteExternalSucceeded, resendInsuranceInviteExternalFailed = _b.resendInsuranceInviteExternalFailed;
export var pollInsuranceStatusExternalStart = (_c = generatePollInsuranceStatusExternalActions(), _c.pollInsuranceStatusExternalStart), pollInsuranceStatusExternalSucceeded = _c.pollInsuranceStatusExternalSucceeded, pollInsuranceStatusExternalFailed = _c.pollInsuranceStatusExternalFailed;
export var resetInsuranceProposalStart = (_d = generateResetInsuranceProposalActions(), _d.resetInsuranceProposalStart), resetInsuranceProposalSucceeded = _d.resetInsuranceProposalSucceeded, resetInsuranceProposalFailed = _d.resetInsuranceProposalFailed;
export var getInsuranceForContractStart = (_e = generateGetInsuranceForContractActions(), _e.getInsuranceForContractStart), getInsuranceForContractSucceeded = _e.getInsuranceForContractSucceeded, getInsuranceForContractFailed = _e.getInsuranceForContractFailed;
